import { render, staticRenderFns } from "./ProfileAddToSession.vue?vue&type=template&id=70137466&"
import script from "./ProfileAddToSession.vue?vue&type=script&lang=js&"
export * from "./ProfileAddToSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports